import { createTheme } from '@mui/material/styles';

import Roboto400 from './fonts/Roboto-400.woff2';
import Roboto500 from './fonts/Roboto-500.woff2';
import Roboto600 from './fonts/Roboto-600.woff2';
import Roboto700 from './fonts/Roboto-700.woff2';

import { palette, cssVariables } from './theme/palette';
import { typography } from './theme/typography';
import { getComponentOverrides } from './theme/components';

const theme = createTheme({
  palette,
  typography,
  components: {
    ...getComponentOverrides(palette),
    MuiCssBaseline: {
      styleOverrides: `
        ${cssVariables}
        @font-face {
          font-family: 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Roboto'), local('Roboto-Regular'), url(${Roboto400}) format('woff2');
        }
        @font-face {
          font-family: 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 500;
          src: local('Roboto Medium'), local('Roboto-Medium'), url(${Roboto500}) format('woff2');
        }
        @font-face {
          font-family: 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 600;
          src: local('Roboto SemiBold'), local('Roboto-SemiBold'), url(${Roboto600}) format('woff2');
        }
        @font-face {
          font-family: 'Roboto';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('Roboto Bold'), local('Roboto-Bold'), url(${Roboto700}) format('woff2');
        }
      `,
    },
  },
});

export default theme;
